import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Moment from 'moment';
import React, { Component, Fragment } from 'react';
import { TooltipMenu, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { submitCalendarEvent, updateCalendarEvent } from 'actions/schedule';
import { getMicrosoftAssignmentDetails } from 'actions/assignments';
import { getSection } from 'actions/sections';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import DatePicker from 'react-datepicker';
import DateTime from '_class/DateTime';
import GroupSelector from './Partials/GroupSelector';
import Modal from 'containers/Modals/Modal';
import { Expandable, Spinner } from 'UI';
import { TimePicker, Editor } from 'UI/Inputs';
import { Checkbox, Button } from '@haldor/ui';
import AssignmentForm from './AssignmentForm/AssignmentForm';
import MultipleAssignmentForm from './AssignmentForm/MultipleAssignmentForm';
import AssignmentSelect from './Partials/AssignmentSelect';
import DisplayAssignment from 'components/BlockEditor/Blocks/AssignmentBlock/DisplayAssignment';
import { getTaskDetails } from 'actions/assignments';

var CalendarEventForm = /*#__PURE__*/function (_Component) {
  _inherits(CalendarEventForm, _Component);

  var _super = _createSuper(CalendarEventForm);

  function CalendarEventForm(props) {
    var _this;

    _classCallCheck(this, CalendarEventForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (value) {
      _this.setState(function (prevState) {
        {
          return {
            selectedAssigments: _this.props.createdGroupAssignment ? [].concat(_toConsumableArray(prevState.selectedAssigments), [_this.props.createdGroupAssignment]) : prevState.selectedAssigments,
            createEvent: false
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeGroupModal", function (value) {
      _this.setState(function (prevState) {
        {
          return {
            selectedAssigments: _this.props.createdAssignments ? [].concat(_toConsumableArray(prevState.selectedAssigments), [_this.props.createdAssignments[0]]) : prevState.selectedAssigments,
            createEvent: false
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleModal", function (name) {
      _this.setState({
        formName: name,
        createEvent: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTestToggle", function (checked) {
      _this.setState({
        examination: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      var editing = _this.props.initialValues != null;
      return new Promise(function (resolve) {
        // edit values object here
        if (_this.state.selectedAssigments.length > 0) {
          var relation = [];

          _this.state.selectedAssigments.map(function (items) {
            var _items$externalID;

            var obj = {
              CalendarEventId: 0,
              ReferenceType: 'ASSIGNMENT',
              ReferenceId: (_items$externalID = items === null || items === void 0 ? void 0 : items.externalID) !== null && _items$externalID !== void 0 ? _items$externalID : items.id
            };
            relation.push(obj);
          });

          values.relationships = relation;
        } else {
          values.relationships = [];
        }

        values.examination = _this.state.examination;

        if (!editing) {
          values.startTime = new DateTime(_this.state.startTime).format();
          values.startTimeUTC = Moment.utc(_this.state.startTime).format();
          values.section = {
            id: _this.state.sectionId
          };
          values.course = _this.state.courses;
          values.length = parseInt(values.length, 10);
          values.addTeamsMeeting = _this.state.createTeamsMeeting;
        }

        if (editing) {
          // Submit form
          _this.props.updateCalendarEvent(values).then(function () {
            resolve(1);
            console.log(values);

            _this.props.onSubmit(values);
          })["catch"](function () {
            // Something went wrong in submission
            resolve(0);
          });
        } else {
          // Submit form
          _this.props.submitCalendarEvent(values).then(function () {
            resolve(1);

            _this.props.onSubmit(values.startTime);

            _this.props.onAbort(true);
          })["catch"](function () {
            // Something went wrong in submission
            resolve(0);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createTeamsMeetingChange", function (active) {
      _this.setState({
        createTeamsMeeting: active
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupChange", function (sectionId, data) {
      var _assertThisInitialize, _assertThisInitialize2;

      _this.setState({
        sectionId: sectionId,
        loadingSection: true,
        sectionObj: data
      });

      if (data && (_assertThisInitialize = _assertThisInitialized(_this)) !== null && _assertThisInitialize !== void 0 && (_assertThisInitialize2 = _assertThisInitialize.props) !== null && _assertThisInitialize2 !== void 0 && _assertThisInitialize2.setModalTitle) {
        var _assertThisInitialize3, _assertThisInitialize4;

        (_assertThisInitialize3 = _assertThisInitialized(_this)) === null || _assertThisInitialize3 === void 0 ? void 0 : (_assertThisInitialize4 = _assertThisInitialize3.props) === null || _assertThisInitialize4 === void 0 ? void 0 : _assertThisInitialize4.setModalTitle(data === null || data === void 0 ? void 0 : data.title);
      }

      _this.props.getSection(sectionId).then(function () {
        _this.setState({
          loadingSection: false
        });
      })["catch"](function (e) {
        console.log(e);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStartChange", function (date) {
      _this.setState({
        startTime: date.second(0)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStartTimeChange", function (time) {
      _this.setState({
        startTime: Moment(time).second(0)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "number", function (value) {
      if (value != null && value != '') {
        // Value is not undefined and not empty
        var number = parseInt(value, 10);

        if (number > 10 && number < 1400) {
          // Field passes validation, return a undefined error for this field
          // Rule: Not undefined and not an empty string and not below zero and not over 1400
          return null;
        }
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('number-field-validation');
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string
        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "quillValidation", function (value) {
      var strValue = value;
      var text = '';

      if (typeof strValue == 'string') {
        text = strValue.replace(/<(?:.|\n)*?>/gm, '');
      }

      if (text == '' || text == null) {
        return _this.props.translate('needs-description');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "onCourseSelect", function (course) {
      var courses = _this.state.courses;
      var group = _this.props.group;
      group.courses.forEach(function (cour) {
        if (course.id != cour.id) {
          cour.selected = false;
        }
      });

      if (course.selected) {
        courses = null;
        course.selected = false;
      } else {
        course.selected = true;
        courses = course;
      }

      _this.setState({
        courses: courses
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectAssignmentForPlan", function (assignment) {
      var plan = _this.props.plan;
      var planId = plan.id;
      var assignments = plan.associatedAssignments;
      var foundIndex = assignments.findIndex(function (as) {
        return as.id == assignment.id;
      });

      if (foundIndex == -1) {
        var newAssignment = null;

        if (assignment.displayName != null) {
          newAssignment = {
            assignmentId: assignment.id,
            key: 'assignment-' + assignment.id,
            title: assignment.displayName,
            teams: true,
            planningId: planId
          };
        } else {
          newAssignment = {
            assignmentId: assignment.id,
            key: 'assignment-' + assignment.id,
            title: assignment.title,
            teams: false,
            planningId: planId
          };
        }

        assignments.push(newAssignment);
        plan.associatedAssignments = assignments; // plan.assignments.push({
        // 	'id': assignment.id,
        // 	'associatedMatrices': [],
        // 	'new': true,
        // 	...newAssignment,
        // });

        _this.setState({
          searchAssignments: !_this.state.searchAssignments
        });

        _this.props.updatePlan(plan).then(function () {
          _this.props.getPlanDetails(_this.props.match.params.planId);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderCourses", function () {
      var group = _this.props.group;

      if (group != null && group.courses != null) {
        return group.courses.map(function (course) {
          if (course.status == 'COURSE_DRAFT') return null;
          var courseTitle = "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(course.courseCode, ")");
          return /*#__PURE__*/React.createElement("div", {
            key: course.id,
            style: {
              marginBottom: '0.75rem'
            }
          }, /*#__PURE__*/React.createElement(Checkbox, {
            value: course.selected,
            onChange: function onChange(c) {
              _this.onCourseSelect(course);
            },
            label: courseTitle
          }));
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onAbort != null) {
        _this.props.onAbort(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "searchAssigment", function (value) {
      var _value$reference;

      var item = (_value$reference = value === null || value === void 0 ? void 0 : value.reference) !== null && _value$reference !== void 0 ? _value$reference : value;

      _this.setState(function (prevState) {
        {
          return {
            selectedAssigments: value ? prevState.selectedAssigments.filter(function (x) {
              return x.id !== item.id;
            }).concat(item) : prevState.selectedAssigments,
            createEvent: false
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeAssigment", function (id) {
      _this.setState(function (prevState) {
        {
          return {
            selectedAssigments: prevState.selectedAssigments.filter(function (x) {
              return x.id !== id.id;
            })
          };
        }
      });
    });

    var _sectionId = 0;

    if (props.sectionId != null) {
      _sectionId = props.sectionId;
    }

    var startTime = Moment().second(0);

    if (props.date != null) {
      startTime = props.date;
    }

    _this.state = {
      sectionId: _sectionId,
      startTime: _this.props.hasDate ? Moment(_this.props.hasDate) : startTime,
      courses: null,
      loadingSection: false,
      createTeamsMeeting: false,
      formName: '',
      createEvent: false,
      sectionObj: {},
      selectedAssigments: [],
      isLoading: false,
      examination: false
    };
    return _this;
  }

  _createClass(CalendarEventForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this,
          _this$props$initialVa,
          _this$props$initialVa2;

      if (this.props.sectionId != null) {
        this.onGroupChange(this.props.sectionId);
      }

      if (this.props.initialValues != null && this.props.sectionId == null) {
        if (this.props.initialValues.section != null && this.props.initialValues.section.id != null) {
          this.setState({
            sectionId: this.props.initialValues.section.id
          });
        }
      }

      if (this.props.group == null && this.props.initialValues !== null) {
        if (this.props.initialValues.section) {
          this.props.getSection(this.props.initialValues.section.id).then(function () {
            _this2.setState({
              loadingSection: false
            });
          })["catch"](function (e) {
            console.log(e);
          });
        }
      }

      if (((_this$props$initialVa = this.props.initialValues) === null || _this$props$initialVa === void 0 ? void 0 : (_this$props$initialVa2 = _this$props$initialVa.relationships) === null || _this$props$initialVa2 === void 0 ? void 0 : _this$props$initialVa2.length) > 0) {
        var _this$props$initialVa3;

        this.setState({
          isLoading: true
        });
        (_this$props$initialVa3 = this.props.initialValues) === null || _this$props$initialVa3 === void 0 ? void 0 : _this$props$initialVa3.relationships.map(function (items) {
          var containsLetters = /[a-zA-Z]/.test(items.referenceId);

          if (containsLetters) {
            _this2.props.getMicrosoftAssignmentDetails(items.referenceId).then(function () {
              if (_this2.props.details != null) {
                _this2.setState(function (prevState) {
                  return {
                    selectedAssigments: [].concat(_toConsumableArray(prevState.selectedAssigments), [_this2.props.details])
                  };
                });
              }
            });
          } else {
            _this2.props.getTaskDetails(items.referenceId).then(function () {
              _this2.setState(function (prevState) {
                {
                  return {
                    selectedAssigments: [].concat(_toConsumableArray(prevState.selectedAssigments), [_this2.props.assignment])
                  };
                }
              });
            });
          }
        });
        this.setState({
          isLoading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$initialVa4,
          _this$props$initialVa5,
          _this$state$sectionOb,
          _this$props$group,
          _this3 = this,
          _this$props2,
          _this$props2$group,
          _this$props$group2,
          _this$props$group3;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid;
      var editing = this.props.initialValues != null;
      var sectionValid = true;

      if (!editing && (this.state.sectionId == null || this.state.sectionId == 0)) {
        sectionValid = false;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, !editing ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(GroupSelector, {
        disabled: this.props.sectionId != null ? true : false,
        onChange: this.onGroupChange,
        required: true,
        sectionId: this.state.sectionId
      })) : null, !editing ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start"
      }, this.props.translate('date')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.startTime,
        onChange: this.onStartChange,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.startTime))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('start-time'), "*"), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: this.props.translate('pick-start-time'),
        time: this.state.startTime,
        onChange: this.onStartTimeChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('length'), "*"), /*#__PURE__*/React.createElement(Field, {
        name: "length",
        type: "text",
        component: this.renderInput,
        placeholder: this.props.translate('length-in-minutes'),
        validate: this.number
      })))) : null, !editing || this.props.initialValues != null && this.props.initialValues.sourceId == null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
        name: "title",
        type: "text",
        component: this.renderInput,
        placeholder: this.props.translate('title'),
        validate: this.required
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('description')), /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "description",
        placeholder: this.props.translate('description'),
        translate: this.props.translate
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('room')), /*#__PURE__*/React.createElement(Field, {
        name: "room",
        type: "text",
        component: this.renderInput,
        placeholder: this.props.translate('room')
      }))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), !editing ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('courses-header-overview')
      }, this.state.sectionId != 0 ? this.state.loadingSection ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : this.renderCourses() : /*#__PURE__*/React.createElement("div", null, this.props.translate('select-relation-error')))) : null, !editing ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('should-this-lesson-be-repeated'), "?"), /*#__PURE__*/React.createElement(Field, {
        component: Checkbox,
        value: this.state.repeatWeekly,
        name: "repeatWeekly",
        label: this.props.translate('repeat-lesson-every') + ' ' + Moment(this.state.startTime).format('dddd')
      })) : null, !editing && this.props.services.teamsMeeting ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('create-teamsmeeting-for-this-lesson'), "?"), /*#__PURE__*/React.createElement(Checkbox, {
        value: this.state.createTeamsMeeting,
        onChange: this.createTeamsMeetingChange,
        label: this.props.translate('create-teamsmeeting-for-this-lesson')
      })) : null, this.props.services.advancedSchedule ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Is the lesson a test')), /*#__PURE__*/React.createElement(Checkbox, {
        value: (_this$props$initialVa4 = (_this$props$initialVa5 = this.props.initialValues) === null || _this$props$initialVa5 === void 0 ? void 0 : _this$props$initialVa5.examination) !== null && _this$props$initialVa4 !== void 0 ? _this$props$initialVa4 : this.state.examination,
        onChange: this.handleTestToggle,
        label: this.props.translate('Show as test')
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Assignments'), " "), /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: /*#__PURE__*/React.createElement(Button, {
          type: 'secondary',
          disabled: this.props.initialValues != null ? false : (_this$state$sectionOb = this.state.sectionObj) !== null && _this$state$sectionOb !== void 0 && _this$state$sectionOb.id && (_this$props$group = this.props.group) !== null && _this$props$group !== void 0 && _this$props$group.id ? false : true
        }, this.props.translate('Add assignment'))
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this3.handleModal('Search assignment');
        }
      }, this.props.translate('Search assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this3.handleModal('Create assignment');
        }
      }, this.props.translate('Create assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this3.handleModal('Create group assignment');
        }
      }, this.props.translate('Create group assignment'))))) : null, this.state.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : this.state.selectedAssigments.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row editor-block active",
        style: {
          marginTop: '2rem',
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Assignments'), " "), /*#__PURE__*/React.createElement("div", {
        className: "block--assignment-block"
      }, this.state.selectedAssigments.map(function (items) {
        return /*#__PURE__*/React.createElement("div", {
          className: "assignment-resource",
          key: items.id
        }, /*#__PURE__*/React.createElement(DisplayAssignment, {
          remove: function remove() {
            return _this3.removeAssigment(items);
          },
          assignment: items
        }));
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || !sectionValid
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, this.props.translate('Cancel'))))), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createEvent,
        onClose: this.closeModal
        /* title={this.props.translate('create-lesson')} */
        ,
        title: this.state.formName === 'Search assignment' ? this.props.translate(this.state.formName) : "".concat(this.props.translate(this.state.formName), " ").concat(this.props.translate('for'), " ").concat((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$group = _this$props2.group) === null || _this$props2$group === void 0 ? void 0 : _this$props2$group.title)
      }, this.state.formName.includes('Search') ? /*#__PURE__*/React.createElement(AssignmentSelect, {
        filterResults: this.props.filterResults,
        onSelect: this.searchAssigment,
        includeAssignmentsWithPlans: false,
        section: this.props.group
      }) : this.state.formName.includes('group') ? /*#__PURE__*/React.createElement(AssignmentForm, {
        onAbort: this.closeModal,
        editView: false,
        cloneView: false,
        groupid: (_this$props$group2 = this.props.group) === null || _this$props$group2 === void 0 ? void 0 : _this$props$group2.id,
        time: this.state.startTime,
        dontRedirect: true,
        length: this.props.length
      }) : /*#__PURE__*/React.createElement(MultipleAssignmentForm, {
        onAbort: this.closeGroupModal,
        editView: false,
        cloneView: false,
        section: this.props.group,
        groupid: (_this$props$group3 = this.props.group) === null || _this$props$group3 === void 0 ? void 0 : _this$props$group3.id,
        time: this.state.startTime,
        length: this.props.length
      })));
    }
  }]);

  return CalendarEventForm;
}(Component);

var selector = formValueSelector('CalendarEvent');

function mapStateToProps(state) {
  return {
    initialValues: state.schedule.activeScheduleItem,
    translate: translate(state.Languages.translations),
    group: state.sections.activeSection,
    createdAssignments: state.assignments.newAssignments,
    createdGroupAssignment: state.assignments.newAssignment,
    services: state.Services.availableServices,
    assignment: state.assignments.active_assignment,
    details: state.assignments.teamsAssignmentDetails,
    length: selector(state, 'length')
  };
}

export default connect(mapStateToProps, {
  submitCalendarEvent: submitCalendarEvent,
  updateCalendarEvent: updateCalendarEvent,
  getSection: getSection,
  getTaskDetails: getTaskDetails,
  getMicrosoftAssignmentDetails: getMicrosoftAssignmentDetails
})(reduxForm({
  form: 'CalendarEvent',
  destroyOnUnmount: true
})(CalendarEventForm));